import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorGiveaway = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M16.014 6v1.938H13.06v1.268c2.39.108 4.189.576 4.189 1.137 0 .56-1.798 1.029-4.189 1.137v3.27h-2.104v-3.269c-2.4-.107-4.207-.575-4.207-1.138s1.807-1.031 4.207-1.138V7.938H8.005V6h8.009Zm-2.953 4.995c1.887-.086 3.285-.396 3.285-.766s-1.398-.68-3.287-.767v1.172a20.1 20.1 0 0 1-2.103 0V9.46c-1.897.086-3.304.396-3.304.768s1.407.683 3.304.768l.124.005h.002c.126.005.253.01.382.012h.012l.11.002h.031l.091.002h.585l.092-.002h.033l.117-.002h.005l.259-.007h.012l.115-.005h.013l.122-.005Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M12 2.7c-4.362 0-7.875 3.469-7.875 7.719 0 2.397 1.114 4.542 2.871 5.96a7.906 7.906 0 0 0 2.494 1.359.75.75 0 0 1-.469 1.425 9.409 9.409 0 0 1-1.146-.463 3 3 0 0 0 .879 2.118l.886.886c.31.31.485.732.485 1.171a.75.75 0 0 1-1.5 0 .155.155 0 0 0-.046-.11l-.886-.886a4.5 4.5 0 0 1-1.318-3.182v-.902a9.5 9.5 0 0 1-.321-.248c-2.09-1.688-3.429-4.253-3.429-7.128C2.625 5.315 6.835 1.2 12 1.2s9.375 4.115 9.375 9.219a9.096 9.096 0 0 1-2.25 5.992v2.513a3.95 3.95 0 0 1-1.157 2.794l-.407.407a1.06 1.06 0 0 0-.311.75.75.75 0 0 1-1.5 0c0-.68.27-1.33.75-1.81l.407-.408a2.45 2.45 0 0 0 .718-1.733V12.75a.75.75 0 0 0-1.5 0v3.375h-.75a2.625 2.625 0 0 0-2.625 2.625v.375a.75.75 0 0 1-1.5 0v-.375a4.126 4.126 0 0 1 3.375-4.057V12.75a2.25 2.25 0 0 1 4.5 0v.961a7.56 7.56 0 0 0 .75-3.292c0-4.25-3.513-7.719-7.875-7.719Z"
    />
  </svg>
);
export default SvgTwoColorGiveaway;
